export function ToProductList(productListInput: any) {
  const productList = [];
  if (productListInput !== null) {
    for (let productCount = 0; productCount < productListInput.length; productCount++) {
      const productItem = productListInput[productCount];
      const product = {
        id: productItem.id,
        name: productItem.name,
        typeId: productItem.typeId,
        unitId: productItem.unitId,
        unitNameEng: productItem.unitNameEng,
        unitNameTh: productItem.unitNameTh,
        description: productItem.description,
        code: productItem.code,
        purchaseAccountId: productItem.purchaseAccountId,
        purchaseVatType: productItem.purchaseVatType,
        purchasePrice: productItem.purchasePrice,
        sellAccountId: productItem.sellAccountId,
        sellVatType: productItem.sellVatType,
        sellPrice: productItem.sellPrice,
        isArchived: productItem.isArchived,
        isDeleted: productItem.isDeleted,
      };
      productList.push(product);
    }
  }
  return productList;
}
